import WhatNew from './WhatNew';

export default WhatNew;
